import { Component, OnInit, Input } from '@angular/core';

import { Button } from 'app/store/models/button.model';
import {
  PriceCardInfo,
  PriceCardColor,
} from 'app/store/models/price-card.model';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-price-card',
  templateUrl: './price-card.component.html',
  styleUrls: ['./price-card.component.scss'],
})
export class PriceCardComponent implements OnInit {
  @Input() info: PriceCardInfo;

  @Input() title: string;

  @Input() iconName: IconProp;

  @Input() text: string;

  @Input() buttons: Button[];

  @Input() color: PriceCardColor;

  constructor() {}

  ngOnInit() {}
}
